module.exports = __webpack_public_path__ + "static/media/home-improvement.6edb8e79.png";